/**
 * PLUGINS.md §3 mcpServers — an MCP server a PLUGIN adds to the ONE MCP catalog (``GET /tools/mcp-registry`` rows
 * carry ``pluginId`` / ``pluginName`` / ``connectionType``). It has no MCP credential: it runs through the plugin's
 * CONNECTION — so the catalog says where it comes from and which connection it uses, instead of asking for a key.
 */

/** PURE — is this catalog row a plugin's MCP? */
export function isPluginMcp(m) {
  return Boolean(m && m.pluginId);
}

/** PURE — "From AWS Manager · uses your AWS account connection" ('' for a platform MCP). ``connLabel`` = the
 *  connection type's display label when the caller has it (else its id). */
export function pluginMcpNote(m, connLabel = '') {
  if (!isPluginMcp(m)) return '';
  const conn = String(connLabel || m.connectionType || '').trim();
  return `From ${m.pluginName || m.pluginId}${conn ? ` · uses your ${conn} connection` : ''}`;
}
